import { Component, AfterViewInit, ViewChild, NgZone, OnInit, HostListener } from '@angular/core';
import { MapLatLng } from '../models/map.latlng';
import { MapBaseDirective } from '../base/map.base';
import { MapService } from '../map.service';
import { GMapComponent } from './gmap.component';
import { MapPlace } from '../models/map.place';

@Component({
  selector: 'lib-gmap-search-movisat',
  templateUrl: './gmap-search.component.html',
  styleUrls: ['./gmap-search.component.css']
})
export class GMapSearchComponent extends MapBaseDirective implements OnInit, AfterViewInit {
  @ViewChild('search', { static: false }) searchElementRef: any;

  public constructor(
    private ngZone: NgZone,
    private mapService: MapService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    // Creo el script de carga para poder poner la ApiKey
    if (!GMapComponent.scritpCreate) {
      GMapComponent.scritpCreate = true;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=' + this.mapService.config?.googleApiKey + '&' +
        'libraries=places,drawing,geometry,visualization&language=' + this.lang + "&callback=initMap";
      document.body.appendChild(script);
      // Este método se llama cuando el mapa se ha cargado
      const script2 = document.createElement('script');
      script2.type = 'text/javascript';
      script2.innerHTML = `function initMap() {
          var event = new CustomEvent("initMap.success");
          window.dispatchEvent(event);
      }`;
      document.body.appendChild(script2);
    }
    this.onInitMap();
  }

  onInitMap() {
    setTimeout(() => {
      // Preparo la búsqueda de direcciones en el mapa
      this.geoCoder = new google.maps.Geocoder();
      let options: any = {};
      const sb = this.searchBounds.split(',');
      if (sb.length === 4) {
        // Restrinjo el área de busqueda preferido
        const sw = new google.maps.LatLng(Number.parseFloat(sb[0]), Number.parseFloat(sb[1]));
        const ne = new google.maps.LatLng(Number.parseFloat(sb[2]), Number.parseFloat(sb[3]));
        options = {
          location: new google.maps.LatLng(sw.lat() + (ne.lat() - sw.lat()) / 2, sw.lng() + (ne.lng() - sw.lng()) / 2),
          bounds: new google.maps.LatLngBounds(sw, ne),
          types: ['geocode']
        }
      } else {
        options = {
          types: ['geocode']
        }
      }
      // Añado la restricción por pais si se ha especificado
      if (this.searchCountry.length >= 2) {
        options.componentRestrictions = {
          country: this.searchCountry
        }
      }
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, options);
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place0: any = autocomplete.getPlace();
          if (place0 && place0.geometry) {
            const lat = place0.geometry.location.lat();
            const lng = place0.geometry.location.lng();
            this.searchElementRef.nativeElement.value = '';
            setTimeout(() => {
              this.searchElementRef.nativeElement.focus()
            }, 500);
            const place = new MapPlace();
            place.Label = place0.formatted_address;
            if (place0.address_components) {
              place0.address_components.forEach((elem: any) => {
                if (elem.types.includes('street_number')) {
                  place.StreetNumber = elem.long_name;
                } else {
                  if (elem.types.includes('route')) {
                    place.Street = elem.long_name;
                  } else {
                    if (elem.types.includes('locality')) {
                      place.Locality = elem.long_name;
                    } else {
                      if (elem.types.includes('administrative_area_level_2')) {
                        place.AdministrativeArea2 = elem.long_name;
                      } else {
                        if (elem.types.includes('administrative_area_level_1')) {
                          place.AdministrativeArea1 = elem.long_name;
                        } else {
                          if (elem.types.includes('country')) {
                            place.Country = elem.long_name;
                          } else {
                            if (elem.types.includes('postal_code')) {
                              place.PostalCode = elem.long_name;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              });
            }
            this.onMapSearch(new MapLatLng(lat, lng), place);
          }
        });
      });
    }, 1000);
  }

}